import {isArrayNullUndefinedOrEmpty} from "../../../services/Validator";
import DetailedGameLevelItem from "../../items/games/DetailedGameLevelItem";

export default function DetailedGameScreenContent({ gameLevels, selectedLevel, setSelectedLevel }) {
    // Used in SingleKnowledgeScreen to display Knowledge
    // related content

    // BUILD
    if (isArrayNullUndefinedOrEmpty(gameLevels))
        return null
    return (
        <div className={"overflow-auto bg-backgroundLight3 grow flex flex-col justify-start px-[16px]"}>
            <div className={"w-full mt-[16px]"}>
                {gameLevels?.map((level, index) => {
                    return <DetailedGameLevelItem key={index}
                                                  isFirst={index === 0}
                                                  level={level}
                                                  selectedLevel={selectedLevel}
                                                  setSelectedLevel={setSelectedLevel} />
                })}
            </div>
        </div>
    );
}